import { render } from "./EventParticipationSlotCompletionRenderer.vue?vue&type=template&id=52d1d9bf&ts=true"
import script from "./EventParticipationSlotCompletionRenderer.vue?vue&type=script&lang=ts"
export * from "./EventParticipationSlotCompletionRenderer.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__